import { useEffect } from 'react'

export function useDetectOutsideClicks(ref: { current: null | HTMLDivElement }, cb: Function) {
  useEffect(() => {
    const onClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        cb()
      }
    }

    document.addEventListener('mousedown', onClickOutside)
    return () => {
      document.removeEventListener('mousedown', onClickOutside)
    }
  }, [ref])
}
